import { getUserProfile } from '../utils';
import { getTbidConfig } from './tbid-config';
import { getDefaultTbidConfigVersionPerEnv } from '../config';
import { ProfileData, UserFieldsCDNSchema } from '../types';
import { validate } from './json_schema_validator';

/**
 * Retrieve user profile information from UserInfo
 * @returns {} user profile info or empty obj
 *
 */
export const getProfileFields = async (
    tbidConfigId: string,
    tbidConfigVersion?: string,
    isOffer?: boolean
): Promise<{
    isProfileComplete: boolean;
    data: ProfileData;
    schema: UserFieldsCDNSchema;
}> => {
    if (tbidConfigVersion === undefined) {
        tbidConfigVersion = getDefaultTbidConfigVersionPerEnv();
    }

    const userProfile = (await getUserProfile())?.userInfo;

    if (!userProfile) {
        return Promise.reject('No TBID session present');
    }

    const [isProfileComplete, data, schema] = await checkProfileCompletion(
        userProfile,
        tbidConfigId,
        tbidConfigVersion,
        isOffer
    );

    return { isProfileComplete, data, schema };
};
/**
 *
 * @param userProfile cannot be undefined
 * @param tbidConfigId Can be any string value
 * @param tbidConfigVersion
 * @returns
 */
export const checkProfileCompletion = async (
    profileData: Record<string, any>,
    tbidConfigId: string,
    tbidConfigVersion: string,
    isOffer?: boolean
): Promise<[boolean, ProfileData, UserFieldsCDNSchema]> => {
    const schema = await getTbidConfig(tbidConfigId, tbidConfigVersion, isOffer);

    if (!schema) {
        return Promise.reject('Invalid tbidConfigId or Version');
    }

    const isProfileComplete = validate(profileData, schema.userFields);
    return [isProfileComplete === undefined, profileData, schema.userFields];
};
